import { SearchXIcon, UsersIcon } from "lucide-react"
import { useTranslation } from "react-i18next"
import { useSearchParams } from "react-router-dom"

import { AppPagination } from "@/components/commons/app-pagination"
import { AppSkeletonTable } from "@/components/commons/app-skeleton-table"
import { Table, TableBody } from "@/components/ui/table"
import { useCustomers } from "@/hooks/use-customers"

import {
  TableContent,
  TableHeaderContent,
} from "./table-components"

export const CustomersTable = () => {
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()

  const params: CustomerSearchParams = {
    page: Number(searchParams.get("page")) || 1,
    pageSize: Number(searchParams.get("pageSize")) || 10,
    name: searchParams.get("name") || undefined,
    document: searchParams.get("document") || undefined,
    email: searchParams.get("email") || undefined,
  }

  const hasSearchParams = Boolean(
    params.name || params.document || params.email
  )

  const { data, isFetching } = useCustomers(
    params,
    hasSearchParams
  )

  const customers = data?.customers || []
  const pagination = data?.pagination
  const paginationData = {
    currentPage: pagination?.currentPage || 1,
    total: pagination?.totalResults || 0,
    totalPages: pagination?.totalPages || 0,
  }

  if (isFetching) return <AppSkeletonTable columns={7} />

  if (!hasSearchParams) {
    return (
      <div className="mt-4 flex flex-1 flex-col items-center justify-center gap-4 text-muted-foreground">
        <UsersIcon size={48} strokeWidth={1.5} />
        <p className="text-center">
          {t("pages.customers.searchToView")}
        </p>
      </div>
    )
  }

  if (!customers || customers.length === 0) {
    return (
      <div className="mt-4 flex flex-1 flex-col items-center justify-center gap-4 text-muted-foreground">
        <SearchXIcon size={48} strokeWidth={1.5} />
        <p className="text-center">
          {t("pages.customers.table.noCustomersFound")}
        </p>
      </div>
    )
  }

  return (
    <>
      <section className="space-y-2 overflow-hidden rounded-md border border-border pb-2">
        <Table>
          <TableHeaderContent />
          <TableBody>
            <TableContent data={customers} />
          </TableBody>
        </Table>
      </section>
      {pagination && pagination.totalPages > 1 && (
        <AppPagination pagination={paginationData} />
      )}
    </>
  )
}
